import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { fetchJobSchedules } from '../services/fetchJobSchedules'

export { useGetJobSchedules }

const queryKey = 'jobs'

const useGetJobSchedules = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isPending: isLoading,
    error,
  } = useQuery({
    queryKey: [queryKey],
    queryFn: () => fetchJobSchedules(),
    enabled: hasPermissions,
    refetchInterval: 1000,
  })

  return {
    data: data || [],
    isLoading,
    error,
  }
}
